import React from 'react';
import { Link } from 'react-router-dom'

export default function Annualgeneralmeeting(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Annual General Meeting</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Annual General Meeting</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="table-responsive table_heading">
				  <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Proceeding of AGM	</th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Proceedings of AGM 27.09.2025</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/proceeding-of-AGM/Proceedings-of-AGM-27.09.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					  <tr>
						<td>Proceedings of AGM 27.09.2024</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/proceeding-of-AGM/proceedings-of-AGM_27.09.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					</tbody>
				  </table>
			
				  <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Postal Ballot	</th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Voting Results AGM 27.09.2025</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/voting-results-AGM-27.09.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					  <tr>
						<td>Voting Results AGM 28.09.2024</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/voting-results-AGM-28.09.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>

					   <tr>
						<td>Scrutinizer's Report</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/Scrutinizer's Report.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>

					</tbody>
				  </table>
				  <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Notice </th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Notice of 41th AGM</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/Notice-of-41th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					  
					  <tr>
						<td>Notice of 40th AGM</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/Notice-of-40th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					  
					  <tr>
						<td>Notice of 39th AGM</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/Notice-of-39th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>
					</tbody>
				  </table>


                <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Transcript of AGM	</th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Transcript of 15th AGM</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/transcript of AGM/Transcript of 15th AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>					 
					</tbody>
				  </table>


                 <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						{/*<th width="20" class="text-center">No.</th>*/}
						<th className="text-left">Financial Statements</th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Financial Statements 2026</td>
						<td width={280} className="text-center">
						<Link to="/GM-and-postal ballot/Financial statement/Financial Statements 2026.pdf" target="_blank">
						Download
					   </Link>{" "}
						</td>
					  </tr>					 
					</tbody>
				  </table>


				</div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}